module.exports = __webpack_public_path__ + "static/media/Floor002-02-01.396743ad.png";